// extracted by mini-css-extract-plugin
module.exports = {"AboutTrustedBlock__title":"AboutTrustedBlock_AboutTrustedBlock__title__BYI96"};